module.exports = __webpack_public_path__ + "img/model-5.e7c25eef.png";